export default {
  detail_extension_fee: 'Extension Fee',
  detail_overdue_charge: 'Penalty Fee',
  detail_extension_period: 'Extension Days',
  detail_amount: 'Loan Amount',
  detail_bill: 'Fee Required',
  detail_tips: 'After the extension, the entire repayment schedule will be postponed by ',
  detail_tips_value: '{day} days',
  confirm_title: 'Things need to know about extension',
  confirm_content1: '1. Payment Deadline: Complete your extension payment by today\'s 24:00. Miss this deadline, and your extension request will be automatically canceled.',
  confirm_content2: '2. Keep Payment Receipt: Retain your payment receipt, it may be necessary for future reference or verification. After completing the payment for the extension, you can return to the App to check your status.',
  confirm_content3: '3. Total Fee Required: If the cumulative payment doesn\'t cover the total fee required by 24:00, the amount will be treated as a loan repayment.',
  agreement1: 'I have read and accept the ',
  agreement2: '<Loan Extension Agreement>',





  title: 'Loan extension',

  list_title: 'Extension History',
  list_time: 'Extension time: {date}',
  list_amount: 'Loan Amount ₱{amount}',
  list_days: 'Extension days',
};
